import { createAction } from 'redux-actions'

export const start = createAction('app/start')
export const reset = createAction('app/reset')



// WEBPACK FOOTER //
// ./src/models/app/actions.js